import { useEffect, useRef } from "react";

export default function BookFireflies() {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        let raf;

        const resize = () => {
            const parent = canvas.parentElement;
            if (!parent) return;
            canvas.width = parent.clientWidth;
            canvas.height = parent.clientHeight;
        };
        resize();
        window.addEventListener("resize", resize);

        const flies = [];
        const COUNT = 14;
        for (let i = 0; i < COUNT; i++) {
            flies.push({
                cx: 0.5 + (Math.random() - 0.5) * 0.36, // relative to canvas
                cy: 0.42 + (Math.random() - 0.5) * 0.30,
                rx: 40 + Math.random() * 110,
                ry: 26 + Math.random() * 70,
                speed: (Math.random() * 0.35 + 0.15) * (Math.random() > 0.5 ? 1 : -1),
                phase: Math.random() * Math.PI * 2,
                blink: Math.random() * Math.PI * 2,
                blinkSpeed: Math.random() * 0.05 + 0.02,
                size: Math.random() * 1.4 + 1.0,
            });
        }

        let last = performance.now();
        const draw = (now) => {
            const dt = Math.min(50, now - last) / 1000;
            last = now;
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            flies.forEach((f) => {
                f.phase += f.speed * dt;
                f.blink += f.blinkSpeed;
                const x = f.cx * canvas.width + Math.cos(f.phase) * f.rx;
                const y = f.cy * canvas.height + Math.sin(f.phase * 0.9) * f.ry;
                const glowPulse = Math.max(0, Math.sin(f.blink));
                const alpha = 0.12 + glowPulse * 0.75;

                const glow = ctx.createRadialGradient(x, y, 0, x, y, f.size * 7);
                glow.addColorStop(0, `rgba(255, 236, 160, ${alpha})`);
                glow.addColorStop(0.35, `rgba(220, 250, 170, ${alpha * 0.45})`);
                glow.addColorStop(1, "rgba(220, 250, 170, 0)");
                ctx.fillStyle = glow;
                ctx.beginPath();
                ctx.arc(x, y, f.size * 7, 0, Math.PI * 2);
                ctx.fill();

                ctx.beginPath();
                ctx.arc(x, y, f.size, 0, Math.PI * 2);
                ctx.fillStyle = `rgba(255, 246, 200, ${Math.min(1, alpha * 1.3)})`;
                ctx.fill();
            });
            raf = requestAnimationFrame(draw);
        };
        raf = requestAnimationFrame(draw);

        return () => {
            cancelAnimationFrame(raf);
            window.removeEventListener("resize", resize);
        };
    }, []);

    return (
        <div className="pointer-events-none absolute inset-0 z-[6]" aria-hidden="true">
            <canvas ref={canvasRef} data-testid="book-fireflies-canvas" className="h-full w-full" />
        </div>
    );
}
